import { roundDecimalPlaces } from './utils.js'

class ParameterCircle {
    constructor(
        cx,
        cy,
        radius,
    ) {
        this.cx = cx
        this.cy = cy
        this.centerPt = {'x': cx, 'y': cy}
        this.r = radius
    }

    // I jettissoned trying to do everything 0-1 
    // with just looping if i/i2 are > 1 to avoid lots of edge cases
    getSubCurveRelative(i, i2, sizing, resolution=0.01) {
        let subCurve = ``
        let sign = i2 > i ? 1 : -1
        let diff = Math.abs(i2 - i)
        let step = roundDecimalPlaces(Math.abs(diff) > resolution ? sign * resolution : diff * sign, 3)
        let prevPt = this.getCoordinates(i)
        let loc = step 
        while (Math.abs(loc) <= diff) {
            let nextPt = this.getCoordinates(i + loc)
            subCurve = `${subCurve} l ${roundDecimalPlaces(sizing * (nextPt.x - prevPt.x), 4)} ${roundDecimalPlaces(sizing * (nextPt.y - prevPt.y), 4)} `
            prevPt = nextPt
            loc = roundDecimalPlaces(loc + step, 3)
        }
        if (loc !== diff) { 
            let endPt = this.getCoordinates(i2)
            subCurve = ` ${subCurve} l ${roundDecimalPlaces(sizing * (endPt.x - prevPt.x), 3)} ${roundDecimalPlaces(sizing * (endPt.y - prevPt.y), 3)}`
        }
        return subCurve
    }

    getSubCurve(i, i2, resolution=0.01) {
        if (Math.abs(i - i2) > 0.5) {
            console.log(`i: ${i}, i2: ${i2}`)
            if (i < i2) {
                i += 1
            } else {
                i2 += 1
            }
            console.log(`i: ${i}, i2: ${i2}`)
        }
        let subCurve = ``
        let sign = i2 > i ? 1 : -1
        let diff = i2 - i 
        let step = Math.abs(diff) > resolution ? sign * resolution : diff
        let loc = step 
        while (Math.abs(loc) <= diff) {
            let nextPt = this.getCoordinates(i + loc)
            subCurve = `${subCurve} L ${roundDecimalPlaces(nextPt.x, 3)} ${roundDecimalPlaces(nextPt.y, 3)} `
            loc += step
        }
        let endPt = this.getCoordinates(i2)
        subCurve = ` ${subCurve} L ${endPt.x} ${endPt.y}`
        return subCurve
    }

    getCoordinates (i) {
        let radians = i * Math.PI * 2
        let x = roundDecimalPlaces(Math.cos(radians) * this.r + this.cx, 3)
        // Inverted to get the correct behavior in svg 
        // since the y coordinates are inverted
        let y = roundDecimalPlaces(-(Math.sin(radians)) * this.r + this.cy, 3)
        return {'x': x, 'y': y}
    }
}

export { ParameterCircle }
